import script from "./TaskCandidateCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCandidateCard.vue?vue&type=script&setup=true&lang=js"

import "./TaskCandidateCard.vue?vue&type=style&index=0&id=065fdc1b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065fdc1b"]])

export default __exports__